import React, { useCallback } from 'react'
import Modal from 'react-bootstrap/Modal'
import { TFunction } from 'i18next'
import { Link } from 'react-router-dom'

interface IModalFooterProps {
	ctaLink: string
	ctaButtonText: string
	showFooterButtonClose: boolean
	isCtaLinkInternalNavigation: boolean
	onClose: () => void
	t: TFunction
}

export const ModalFooter = ({
	ctaLink,
	ctaButtonText,
	showFooterButtonClose,
	isCtaLinkInternalNavigation,
	onClose,
	t,
}: IModalFooterProps) => {
	const handleCtaClick = useCallback(() => {
		onClose()
	}, [onClose])

	const renderCtaButton = () => {
		if (!ctaLink || !ctaButtonText) return null

		const button = (
			<button type="button" className="btn btn-primary">
				{ctaButtonText}
			</button>
		)

		return isCtaLinkInternalNavigation ? (
			<Link to={ctaLink} onClick={handleCtaClick}>
				{button}
			</Link>
		) : (
			<a
				href={ctaLink}
				target="_blank"
				rel="noopener noreferrer"
				onClick={handleCtaClick}>
				{button}
			</a>
		)
	}

	return (
		<Modal.Footer>
			{renderCtaButton()}
			{showFooterButtonClose && (
				<button
					type="button"
					className="btn btn-secondary"
					onClick={onClose}>
					{t('Close')}
				</button>
			)}
		</Modal.Footer>
	)
}
